module.exports = __webpack_public_path__ + "img/jhPageJimeng2.0e962e2f.png";